import React from 'react';

function LoadingSpinner({ size = 40 }) {
  return (
    <div className="flex justify-center" style={{ padding: '40px 0' }}>
      <div
        className="spinner"
        style={{
          width: size,
          height: size
        }}
      />
    </div>
  );
}

export default LoadingSpinner;
